import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { User, Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0101. ワークスペース詳細
 * [GET] /workspaces/:identifier
 */
type WorkspaceResponse = {
  workspace: Workspace;
  user: User;
};

const workspace = (identifier: string): Promise<WorkspaceResponse> => {
  return axios.get(`/api/workspaces/${identifier}`);
};

export const useWorkspace = (identifier: string) => {
  return useQuery({
    queryKey: ['workspace', identifier],
    queryFn: () => workspace(identifier),
  });
};

export const useWorkspaceInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspace', identifier] });
  };

  return { invalidate };
};
